var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Table',{staticStyle:{"width":"100%"},attrs:{"columns":_vm.columns1,"data":_vm.ChargeCards,"size":"small"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }